import React from "react";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function MetricOptionText({ metric }) {
  return (
    <>
      <ListItemText
        primary={metric.label}
        sx={{ minWidth: 0 }}
        primaryTypographyProps={{ sx: { whiteSpace: "normal", overflowWrap: "anywhere" } }}
      />
      {metric.description && (
        <InfoOutlinedIcon
          aria-hidden="true"
          sx={{ color: "#6d28d9", fontSize: 18, flexShrink: 0, ml: 2 }}
        />
      )}
    </>
  );
}

// Keep the option itself as the keyboard target: MUI Select uses arrow-key
// navigation and closes on Tab, so a nested info button would be unreachable.
// Tooltip adds the definition as a description without replacing the label.
export const MetricOptionMenuItem = React.forwardRef(function MetricOptionMenuItem(
  { metric, children, ...props },
  ref
) {
  const narrowScreen = useMediaQuery("(max-width:600px)");
  return (
    <Tooltip
      title={metric.description || ""}
      placement={narrowScreen ? "bottom" : "right"}
      arrow
      describeChild
      componentsProps={{ tooltip: { sx: { maxWidth: "min(300px, calc(100vw - 32px))" } } }}
      PopperProps={{ modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom", "top", "left"] } }] }}
    >
      <MenuItem {...props} ref={ref} aria-label={metric.label}>
        {children}
        <MetricOptionText metric={metric} />
      </MenuItem>
    </Tooltip>
  );
});
